import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_CONFIG = {
  /*publicKey: 'nKEfTSqnjl69ECkir',
  serviceId: 'service_8eb0z63', 
  orderTemplateId: 'template_vhcpd5t',
  contactTemplateId: 'template_e42m5rh' // Double-check this ID*/
  publicKey: 'KGq63sdmZvJHGpDM-',
  serviceId: 'service_7lx2dqh', 
  orderTemplateId: 'template_i7juvjw',
  contactTemplateId: 'template_eb5otpk' // Double-check this ID
};

export const emailService = {
  // Initialize EmailJS
  init: () => {
    emailjs.init(EMAILJS_CONFIG.publicKey);
  },

  // Send order email - KEEP AS IS
  sendOrderEmail: async (orderData) => {
    try {
      const orderId = 'BP' + Date.now().toString().slice(-6);
      
      const templateParams = {
        to_email: 'simolakhdar9979@gmail.com',
        customer_name: orderData.fullName,
        customer_phone: orderData.phone,
        delivery_address: orderData.address,
        product_name: orderData.productName,
        product_price: orderData.productPrice,
        product_list: orderData.productsList,
        total_items: orderData.totalItems,
        order_date: orderData.orderDate,
        order_id: orderId,
        customer_promo_code: orderData.promoCode || 'N/A'
      };

      const response = await emailjs.send(
        EMAILJS_CONFIG.serviceId,
        EMAILJS_CONFIG.orderTemplateId,
        templateParams
      );

      return response;
    } catch (error) {
      console.error('Error sending order email:', error);
      throw error;
    }
  },

  // Send contact email with debugging
  sendContactEmail: async (contactData) => {
    try {
      console.log('🔍 EmailJS Config:', {
        serviceId: EMAILJS_CONFIG.serviceId,
        templateId: EMAILJS_CONFIG.contactTemplateId,
        publicKey: EMAILJS_CONFIG.publicKey
      });

      const templateParams = {
        from_name: contactData.name,
        from_email: contactData.email,
        message: contactData.message,
        promoCode: contactData.promoCode || 'N/A',
        contact_date: new Date().toLocaleDateString('fr-FR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      };

      console.log('📧 Template params:', templateParams);
      console.log('🎯 Using template ID:', EMAILJS_CONFIG.contactTemplateId);

      const response = await emailjs.send(
        EMAILJS_CONFIG.serviceId,
        EMAILJS_CONFIG.contactTemplateId,
        templateParams
      );

      console.log('✅ Contact email sent successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ Detailed error sending contact email:', {
        error: error,
        message: error.message,
        status: error.status,
        text: error.text
      });
      throw error;
    }
  }
};